/**
 * Smoothly scrolls to an in-page anchor without relying on hash navigation,
 * which can be unreliable inside embedded previews and iframes.
 */
export function scrollToSection(
  event: React.MouseEvent<HTMLAnchorElement>,
  href: string,
  onDone?: () => void,
) {
  if (!href.startsWith('#')) return

  const id = href.slice(1)
  const target = document.getElementById(id)
  if (!target) return

  event.preventDefault()

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  target.scrollIntoView({
    behavior: prefersReducedMotion ? 'auto' : 'smooth',
    block: 'start',
  })

  window.history.replaceState(null, '', href)
  onDone?.()
}
